import {
  editTips,
  removeTips,
  updateTips,
  editTipsAtomic,
} from './actions';

export default {
  [editTips]: (state, { payload: { data } }) => {
    const { id, ...rest } = data;

    return {
      ...state,
      tips: {
        ...state.tips,
        [id]: {
          ...state.tips[id],
          ...rest,
        },
      },
    };
  },
  [removeTips]: (state, { payload: { data: { id, deletedAt, deletedBy } } }) => ({
    ...state,
    tips: {
      ...state.tips,
      [id]: {
        ...state.tips[id],
        deletedAt,
        deletedBy,
        archived: true,
      },
    },
  }),
  [updateTips]: (state, { payload: { data } }) => ({
    ...state,
    tips: {
      ...state.tips,
      ...data,
    },
  }),
  [editTipsAtomic]: (state, { payload: { id, field, value, updatedAt, updatedBy } }) => ({
    ...state,
    tips: {
      ...state.tips,
      [id]: {
        ...state.tips[id],
        [field]: value,
        updatedAt,
        updatedBy,
      },
    },
  }),
};
